import React from 'react';
import { Edit, SimpleForm, BooleanInput, useGetList } from 'react-admin';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import EditTitle from '../../../ui/edit-title';
import CustomEditToolbar from '../../../ui/custom-edit-toolbar';
import CustomTextField from '../../../ui/custom-text-field';
import CustomSelect from '../../../ui/custom-select';
import { minLength } from '../../../utils/schemas';
import { ContentPageSX } from '../../../styled/custom';

const Schema = Yup.object(
{
  name: minLength(3, "Digite o nome")
});

const normalizeCategoriesMedia = (categoriesMedia) =>
{
  if (!Array.isArray(categoriesMedia))
    return categoriesMedia;

  return categoriesMedia
    .map(categoryMedia => typeof categoryMedia === 'object' && categoryMedia != null ? categoryMedia.id : categoryMedia)
    .filter(categoryMediaId => categoryMediaId !== '' && categoryMediaId != null);
};

const transformTypePlanPayload = (data) =>
{
  return {
    ...data,
    categories_media: normalizeCategoriesMedia(data.categories_media)
  };
};

const TypePlanEdit = (props) =>
{
  const { data: categoriesMediaData, isLoading: isLoadingCategoriesMedia } =
    useGetList('category-media', { pagination: { page: 1, perPage: 1000000 }});

  return (
    <Edit
      title={ <EditTitle subtitle="Editar Tipo de Plano: " source="name" /> }
      redirect="list"
      mutationMode="pessimistic"
      transform={transformTypePlanPayload}
      sx={ContentPageSX}>
      <SimpleForm
        noValidate
        resolver={yupResolver(Schema)}
        toolbar={ <CustomEditToolbar /> }>
        <CustomTextField source="id" label="Id" disabled />
        <CustomTextField name="name" label="Nome" fullWidth />
        <BooleanInput source="has_audio" label="Acesso a Áudio" />
        <BooleanInput source="has_text" label="Acesso a Texto" />
        <BooleanInput source="has_video" label="Acesso a Vídeo" />
        {!isLoadingCategoriesMedia && (
          <CustomSelect
            data={categoriesMediaData}
            name="categories_media"
            label="Categorias de Mídia Incluídas"
            fullWidth />
        )}
        <BooleanInput source="active" label="Ativo" />
      </SimpleForm>
    </Edit>
  );
};

export default TypePlanEdit;
